import { useEffect, useRef, useState } from 'react';

import { buildQueryParams } from '../helpers/handleUpdateSearchParams';

export const useFetchDataOnLoad = ({
    client,
    route,
    searchParams,
    onError,
    triggerRefetch = [],
    formatResponse,
}) => {
    const [data, setData] = useState(null);

    const controller = useRef(new AbortController());

    useEffect(() => {
        const fetchData = async () => {
            try {
                controller.current?.abort();
                controller.current = new AbortController();

                if (!!triggerRefetch?.length) {
                    setData(null);
                }

                const queryParams = buildQueryParams(searchParams);
                const url = route + (queryParams ? `?${queryParams}` : '');

                const { data: response } = await client.get(url, {
                    signal: controller.current.signal,
                });

                let formattedData = response;
                if (formatResponse) {
                    formattedData = formatResponse(response);
                }

                setData(formattedData);
            } catch (e) {
                if (e.message === 'canceled') {
                    return;
                }
                onError && onError(e);
            }
        };

        void fetchData();
    }, [...triggerRefetch]);

    return { data, setData };
};
